import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class OvelhinhasProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  private instituicaoFiltragem = null

  constructor(public http: HttpClient) {}

  getLayoutListagem() {
    return this.http.get<any>(this.baseUrl + '/ovelhinhas/get-layout-listagem', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getFamiliares(isImprimir, idade, idInstituicaoFiltro = null) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/get-familiares', {
        isImprimir: isImprimir,
        idade: idade,
        idInstituicaoFiltro: idInstituicaoFiltro,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  updatePessoa(pessoa) {
    return this.http.post<any>(this.baseUrl + '/ovelhinhas/update-pessoa', { pessoa: pessoa }).map((data) => {
      return data;
    });
  }

  removerFamiliar(idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/remover-familiar', {
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  inscreverReuniao(idPessoa, familiares, apiToken, idInstituicaoFiltro = null) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/inscrever-reuniao', {
        idPessoa: idPessoa,
        familiares: familiares,
        apiToken: apiToken,
        idInstituicaoFiltro: idInstituicaoFiltro,
      })
      .map((data) => {
        return data;
      });
  }

  getOvelhinhas(idInstituicaoFiltro = null) {
    return this.http.get<any>(this.baseUrl + '/ovelhinhas/get-ovelhinhas', {
      params: {
        idInstituicaoFiltro: idInstituicaoFiltro,
      },
    }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getOvelhinhasResponsavel() {
    return this.http.get<any>(this.baseUrl + '/ovelhinhas/get-ovelhinhas-responsavel', {
      params: {
        idInstituicaoFiltro: this.getInstituicaoFiltragem()
      },
    }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  buscarReunioesOvelhinha(idOvelhinha) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/buscar-reunioes-ovelhinha', {
        idOvelhinha: idOvelhinha,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getParticipantesReuniao(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/ovelhinhas/get-participantes-reuniao', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          q: filtro.q,
          id: filtro.id ? filtro.id : '',
          t: filtro.t,
          idReuniao: filtro.idReuniao ? filtro.idReuniao : '',
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          pessoas: data.body,
          pagination: pag,
        };
      });
  }

  removerParticipante(idReuniao, idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/remover-participante', {
        idReuniao: idReuniao,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  saidaParticipante(idReuniao, participante) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/saida-participante', {
        idReuniao: idReuniao,
        participante: participante,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  addParticipantesReuniao(inscricao) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/add-participantes-reuniao', {
        inscricao: inscricao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarVinculoDependentes(responsavel, dependentes) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/salvar-vinculo-dependentes', {
        responsavel: responsavel,
        dependentes: dependentes,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  imprimirEtiquetaParticipante(dados, apiToken) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/imprimir-etiqueta-participante', {
        dados: dados,
        apiToken: apiToken,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getResponsaveis(idOvelhinha) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/get-responsaveis', {
        idOvelhinha: idOvelhinha,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getRunioes(idOvelhinha) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/get-reunioes', {
        idOvelhinha: idOvelhinha,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarReuniao(idOvelhinha, reuniao) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/salvar-reuniao', {
        idOvelhinha: idOvelhinha,
        reuniao: reuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getParticipantesPorReuniao(idOvelhinha) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/get-participantes-por-reuniao', {
        idOvelhinha: idOvelhinha,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  isRegrasOvelhinhas(idReuniao, pessoa) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/is-regras-ovelhinhas', {
        idReuniao: idReuniao,
        pessoa: pessoa,
      })
      .map((data) => {
        return data;
      });
  }

  reCheckIn(idDependente, idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/ovelhinhas/re-check-in', {
        idDependente: idDependente,
        idReuniao: idReuniao,
      })
      .map((data) => {
        return data;
      });
  }

  setInstituicaoFiltragem(instituicao) {
    this.instituicaoFiltragem = instituicao;
  }

  getInstituicaoFiltragem() {
    return this.instituicaoFiltragem;
  }
}



// WEBPACK FOOTER //
// ./src/providers/ovelhinhas/ovelhinhas.ts